import { createApp } from 'vue';
import MediaBlock from './ArticleMediaBlock.vue';
import "./ArticleMediaBlock.scss"

export default function mountArticleMediaBlock() {

	const blocks = document.querySelectorAll('[data-feature="articleMediaBlock"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'ArticleMediaBlockApp',
		});

		app.component('article-media-block', MediaBlock);
		app.mount(block);
	})
}

mountArticleMediaBlock()